import Vue from 'vue'
import Router from 'vue-router'

// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/* Layout */
import Layout from '../views/admin/layout/Layout'

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/
export const constantRouterMap = [
  { path: '/forgot', component: () => import('@/views/forgot/index'), hidden: true },
  { path: '/response/:email', component: () => import('@/views/forgot/response'), hidden: true },
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/reset', component: () => import('@/views/forgot/reset'), hidden: true },
  { path: '/success', component: () => import('@/views/forgot/success'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  { path: '', component: () => import('@/views/home/index'), hidden: true },
  { path: '/register', component: () => import('@/views/home/register'), hidden: true },
  { path: '/legal', component: () => import('@/views/legal/legal'), hidden: true },
  { path: '/privacy', component: () => import('@/views/legal/privacy'), hidden: true },
  { path: '/cookie', component: () => import('@/views/legal/cookie'), hidden: true },
  { path: '/unconfirmed', component: () => import('@/views/unconfirmed/index'), hidden: true },
  { path: '/public', component: () => import('@/views/public/index'), hidden: true },
  { path: '/product', component: () => import('@/views/public/product'), hidden: true },
  { path: '/p/:branchId/sample/registration', component: () => import('@/views/sample/registrations/public'), hidden: true },
  { path: '/p/meticulousmaid/:branchId/public', component: () => import('@/views/meticulousmaid/bookings/public'), hidden: true },
  { path: '/maid', component: () => import('@/views/meticulousmaid/bookings/public2'), hidden: true },
  { path: '/psb/login', component: () => import('@/views/psb/login/index'), hidden: true },
  { path: '/smedpoc/login', component: () => import('@/views/smedpoc/login/index'), hidden: true },
  { path: '/p/emailblaster/:branchId/public', component: () => import('@/views/emailblaster/newsletters/public'), hidden: true },
  { path: '/p/speedtrap/:branchId/public', component: () => import('@/views/speedtrap/reports/public'), hidden: true },
  { path: '/p/mindblogging/:userHandle/:blogHandle', component: () => import('@/views/mindblogging/blogs/public'), hidden: true },
  { path: '/speedtrap', component: () => import('@/views/speedtrap/reports/public2'), hidden: true },

  // Archive Versions
  // v1
  { path: '/v/v1/login', component: () => import('@/views/home/v1/index'), hidden: true },
]

export default new Router({
  // mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
  mode: 'history'
})

export const unconfirmedRouterMap = [
  { path: '/dashboard', component: () => import('@/views/unconfirmed/index'), hidden: true }
]

export const rejectedRouterMap = [
  { path: '/dashboard', component: () => import('@/views/unconfirmed/rejected'), hidden: true }
]

export const asyncRouterMap = [
  {
    path: '/z/:branchId/accounting',
    component: Layout,
    redirect: 'accounting/general',
    name: 'Accounting',
    meta: { feature: 'accounting', title: 'Accounting', icon: 'accounting' },
    children: [
      {
        path: 'general',
        component: () => import('@/views/accounting/ledgers/index'),
        meta: { title: 'General Ledger', icon: 'accounting' }
      },
      {
        path: 'recurrences',
        component: () => import('@/views/accounting/recurrences/index'),
        meta: { title: 'Recurrences', icon: 'accounting' }
      },
      {
        path: 'compliances',
        component: () => import('@/views/accounting/compliances/index'),
        meta: { title: 'Compliances', icon: 'accounting' }
      },
      {
        path: 'bankstatements',
        component: () => import('@/views/accounting/bankstatements/index'),
        meta: { title: 'Bank Statements', icon: 'accounting' }
      },
      {
        path: 'settings',
        component: () => import('@/views/accounting/settings/index'),
        meta: { title: 'Settings', icon: 'accounting' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/sample',
    component: Layout,
    redirect: 'sample',
    name: 'Sample',
    meta: { feature: 'sample', title: 'Sample', icon: 'ow_clock1' },
    children: [
      {
        path: '',
        component: () => import('@/views/sample/registrations/index'),
        meta: { title: 'Sample', icon: 'ow_clock1' }
      }
    ],
    branch: true
  },
  {
    path: '/z/:branchId/file',
    component: Layout,
    redirect: 'file',
    name: 'File',
    meta: { feature: 'file', title: 'File', icon: 'ow_clock1' },
    children: [
      {
        path: '',
        component: () => import('@/views/file/uploads/index'),
        meta: { title: 'File', icon: 'ow_clock1' }
      }
    ],
    branch: true
  },
  {
    path: '/z/:branchId/zafinabot',
    component: Layout,
    redirect: '/zafinabot/account',
    name: 'Zafina BOT',
    meta: { feature: 'zafinabot', title: 'Zafina BOT', icon: 'ow_clock1' },
    children: [
      {
        path: 'account',
        component: () => import('@/views/zafinabot/telegramaccount/index'),
        meta: { title: 'Account', icon: 'ow_clock1' }
      },
      {
        path: 'chat',
        component: () => import('@/views/zafinabot/telegramchat/index'),
        meta: { title: 'Chat', icon: 'ow_clock1' }
      }
    ],
    branch: true
  },
  {
    path: '/z/:branchId/meticulousmaid',
    component: Layout,
    redirect: '/meticulousmaid/booking',
    name: 'Meticulous Maid',
    meta: { feature: 'meticulousmaid', title: 'Meticulous Maid', icon: 'ow_clock1' },
    children: [
      {
        path: 'booking',
        component: () => import('@/views/meticulousmaid/bookings/index'),
        meta: { title: 'Booking', icon: 'ow_clock1' }
      },
      {
        path: 'calendar',
        component: () => import('@/views/meticulousmaid/bookings/calendar'),
        meta: { title: 'Calendar', icon: 'ow_clock1' }
      }
    ],
    branch: true
  },
  {
    path: '/z/:branchId/emailblaster',
    component: Layout,
    redirect: '/emailblaster/newsletter',
    name: 'Email Blaster',
    meta: { feature: 'emailblaster', title: 'Email Blaster', icon: 'ow_clock1' },
    children: [
      {
        path: 'newsletter',
        component: () => import('@/views/emailblaster/newsletters/index'),
        meta: { title: 'Newsletter', icon: 'ow_clock1' }
      }
    ],
    branch: true
  },
  {
    path: '/z/:branchId/speedtrap',
    component: Layout,
    redirect: '/speedtrap/report',
    name: 'Speedtrap',
    meta: { feature: 'speedtrap', title: 'Speedtrap', icon: 'ow_clock1' },
    children: [
      {
        path: 'report',
        component: () => import('@/views/speedtrap/reports/index'),
        meta: { title: 'Report', icon: 'ow_clock1' }
      },
      {
        path: 'report/map',
        component: () => import('@/views/speedtrap/reports/map'),
        meta: { title: 'Map', icon: 'ow_clock1' }
      },
      {
        path: 'report/test',
        component: () => import('@/views/speedtrap/reports/test'),
        meta: { title: 'Test', icon: 'ow_clock1' }
      }
    ],
    branch: true
  },
  {
    path: '/z/:branchId/taskmaster',
    component: Layout,
    redirect: 'taskmaster/task',
    name: 'Taskmaster',
    meta: { feature: 'taskmaster', title: 'Taskmaster', icon: 'taskmaster' },
    children: [
      {
        path: 'task',
        component: () => import('@/views/taskmaster/tasks/index'),
        meta: { title: 'Taskmaster', icon: 'taskmaster' }
      }
    ],
    branch: true
  },
  {
    path: '/z/:branchId/compliance',
    component: Layout,
    redirect: 'compliance/general',
    name: 'Compliance',
    meta: { feature: 'compliance', title: 'Compliance', icon: 'ow_clock1' },
    children: [
      {
        path: 'compliances',
        component: () => import('@/views/compliance/compliances/index'),
        meta: { title: 'Compliance', icon: 'ow_clock1' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/sirimsts',
    component: Layout,
    redirect: 'sirimsts/title',
    name: 'Sirim STS',
    meta: { feature: 'sirimsts', title: 'Sirim STS', icon: 'ow_clock1' },
    children: [
      {
        path: 'title',
        component: () => import('@/views/sirimsts/titles/index'),
        meta: { title: 'Title', icon: 'ow_clock1' }
      }
    ],
    branch: true
  },
  {
    path: '/z/:branchId/datacenter',
    component: Layout,
    redirect: 'datacenter/serverstatuses',
    name: 'Datacenter',
    meta: { feature: 'datacenter', title: 'Datacenter', icon: 'ow_clock1' },
    children: [
      {
        path: 'serverstatuses',
        component: () => import('@/views/datacenter/serverstatuses/index'),
        meta: { title: 'Datacenter', icon: 'ow_clock1' }
      }
    ],
    branch: true
  },
  {
    path: '/z/:branchId/psb',
    component: Layout,
    redirect: 'psb/categories',
    name: 'PSB',
    meta: { feature: 'psb', title: 'PSB', icon: 'ow_clock1' },
    children: [
      {
        path: 'categories',
        component: () => import('@/views/psb/categories/index'),
        meta: { relationRoles: ['PSB'], title: 'Categories', icon: 'ow_clock1' }
      },
      {
        path: 'boxes',
        component: () => import('@/views/psb/boxes/index'),
        meta: { relationRoles: ['PSB'], title: 'Boxes', icon: 'ow_clock1' }
      },
      {
        path: 'customers',
        component: () => import('@/views/psb/customers/index'),
        meta: { relationRoles: ['PSB'], title: 'Customers', icon: 'ow_clock1' }
      },
      {
        path: 'rentals',
        component: () => import('@/views/psb/rentals/index'),
        meta: { title: 'Rentals', icon: 'ow_clock1' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/videotape',
    component: Layout,
    redirect: 'videotape',
    name: 'Videotape',
    meta: { feature: 'videotape', title: 'Videotape', icon: 'ow_clock1' },
    children: [
      {
        path: '',
        component: () => import('@/views/videotape/index'),
        meta: { title: 'Videotape', icon: 'ow_clock1' }
      }
    ],
    branch: true
  },
  {
    path: '/z/:branchId/business',
    component: Layout,
    redirect: 'business/quotation',
    name: 'Business',
    meta: { feature: 'commercial', title: 'Business', icon: 'business' },
    children: [
      {
        path: 'quotation',
        component: () => import('@/views/commercial/quotations/index'),
        meta: { title: 'Quotation', icon: 'business' }
      },
      // {
      //   path: 'sales',
      //   component: () => import('@/views/commercial/orders/index'),
      //   meta: { title: 'Sales Order', icon: 'business' }
      // },
      {
        path: 'delivery',
        component: () => import('@/views/commercial/delivery/index'),
        meta: { title: 'Delivery Order', icon: 'business' }
      },
      {
        path: 'invoice',
        component: () => import('@/views/commercial/invoices/index'),
        meta: { title: 'Invoice', icon: 'business' }
      },
      {
        path: 'receipt',
        component: () => import('@/views/commercial/receipts/index'),
        meta: { title: 'Receipt', icon: 'business' }
      },
      {
        path: 'client',
        component: () => import('@/views/commercial/clients/index'),
        meta: { title: 'Client', icon: 'business' }
      },
      {
        path: 'product',
        component: () => import('@/views/commercial/product/index'),
        meta: { title: 'Products', icon: 'business' }
      }
      // {
      //   path: '/sales',
      //   component: Layout,
      //   redirect: 'sales/delivery',
      //   name: 'Sales',
      //   meta: { title: 'Sales', icon: 'business' },
      //   children: [
      //     // {
      //     //   path: '',
      //     //   name: 'sales',
      //     //   component: () => import('@/views/admin/orders/index'),
      //     //   meta: { title: 'Sales Order', icon: 'business' }
      //     // },
      //     // {
      //     //   path: 'cashsale',
      //     //   name: 'cashsales',
      //     //   component: () => import('@/views/admin/sales/index'),
      //     //   meta: { title: 'Cash Sale', icon: 'business' }
      //     // },
      //     {
      //       path: 'delivery',
      //       name: 'delivery',
      //       component: () => import('@/views/admin/delivery/index'),
      //       meta: { title: 'DO', icon: 'business' }
      //     },
      //     {
      //       path: 'invoice',
      //       name: 'invoice',
      //       component: () => import('@/views/admin/invoices/index'),
      //       meta: { title: 'Invoice', icon: 'business' }
      //     }
      //   ]
      // },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mindblogging',
    component: Layout,
    redirect: 'mindblogging',
    name: 'Mindblogging',
    meta: { feature: 'mindblogging', title: 'Mindblogging', icon: 'ow_clock1' },
    children: [
      {
        path: 'blogs',
        component: () => import('@/views/mindblogging/blogs/index'),
        meta: { title: 'Mindblogging', icon: 'ow_clock1' }
      }
    ],
    branch: true
  },
  {
    path: '/z/:branchId/smedpoc',
    component: Layout,
    redirect: 'smed-poc',
    name: 'SMED-POC',
    meta: { feature: 'smedpoc', title: 'SMED-POC', icon: 'ow_clock1' },
    children: [
      {
        path: 'kenderaan-kesalahan2',
        component: () => import('@/views/smedpoc/kenderaan-kesalahan2/index'),
        meta: { title: 'SMED-POC 2', icon: 'ow_clock1' }
      },
      {
        path: 'kenderaan-kesalahan',
        component: () => import('@/views/smedpoc/kenderaan-kesalahan/index'),
        meta: { title: 'SMED-POC', icon: 'ow_clock1' }
      },
      {
        path: 'camera-sim',
        component: () => import('@/views/smedpoc/camera-sim/index'),
        meta: { title: 'Camera SIM', icon: 'ow_clock1' }
      },
      {
        path: 'vehicle-registration',
        component: () => import('@/views/smedpoc/vehicle-registration/index'),
        meta: { title: 'Vehicle Reg', icon: 'ow_clock1' }
      },
      {
        path: 'jenis-kesalahan',
        component: () => import('@/views/smedpoc/jenis-kesalahan/index'),
        meta: { title: 'Jenis Kesalahan', icon: 'ow_clock1' }
      }
    ],
    branch: true
  },
  {
    path: '/z/:branchId/binance',
    component: Layout,
    redirect: 'binance',
    name: 'Binance',
    meta: { feature: 'binance', title: 'Binance', icon: 'ow_clock1' },
    children: [
      {
        path: 'reports',
        component: () => import('@/views/binance/reports/index'),
        meta: { title: 'Binance', icon: 'ow_clock1' }
      },
      // {
      //   path: 'currencies',
      //   component: () => import('@/views/binance/currencies/index'),
      //   meta: { title: 'Currencies', icon: 'ow_clock1' }
      // }
    ],
    branch: true
  },
  {
    path: '/z/:branchId/chatgpt',
    component: Layout,
    redirect: 'chatgpt',
    name: 'ChatGPT',
    meta: { feature: 'chatgpt', title: 'ChatGPT', icon: 'ow_clock1' },
    children: [
      {
        path: 'chat',
        component: () => import('@/views/chatgpt/chat/index'),
        meta: { title: 'Chat', icon: 'ow_clock1' }
      },
      {
        path: 'settings',
        component: () => import('@/views/chatgpt/settings/index'),
        meta: { title: 'Settings', icon: 'ow_clock1' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/leonardoai',
    component: Layout,
    redirect: 'leonardoai',
    name: 'LeonardoAI',
    meta: { feature: 'leonardoai', title: 'LeonardoAI', icon: 'ow_clock1' },
    children: [
      {
        path: 'prompts',
        component: () => import('@/views/leonardoai/prompts/index'),
        meta: { title: 'Prompts', icon: 'ow_clock1' }
      },
      {
        path: 'settings',
        component: () => import('@/views/leonardoai/settings/index'),
        meta: { title: 'Settings', icon: 'ow_clock1' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mashmixup',
    component: Layout,
    redirect: 'mashmixup',
    name: 'MashMixUp',
    meta: { feature: 'mashmixup', title: 'MashMixUp', icon: 'ow_clock1' },
    children: [
      {
        path: 'prompts',
        component: () => import('@/views/mashmixup/prompts/index'),
        meta: { title: 'Prompts', icon: 'ow_clock1' }
      },
      {
        path: 'settings',
        component: () => import('@/views/mashmixup/settings/index'),
        meta: { title: 'Settings', icon: 'ow_clock1' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/fireman',
    component: Layout,
    redirect: 'fireman',
    name: 'Fireman',
    meta: { feature: 'fireman', title: 'Fireman', icon: 'ow_clock1' },
    children: [
      {
        path: 'firedoc',
        component: () => import('@/views/fireman/firedocs/index'),
        meta: { title: 'Firedoc', icon: 'ow_clock1' }
      },
      {
        path: 'settings',
        component: () => import('@/views/fireman/settings/index'),
        meta: { title: 'Settings', icon: 'ow_clock1' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/drawio',
    component: Layout,
    redirect: 'drawio',
    name: 'DrawLO',
    meta: { feature: 'drawio', title: 'DrawLO', icon: 'ow_clock1' },
    children: [
      {
        path: 'draw',
        component: () => import('@/views/drawio/draw/index'),
        meta: { title: 'Draw', icon: 'ow_clock1' }
      },
      {
        path: 'settings',
        component: () => import('@/views/drawio/settings/index'),
        meta: { title: 'Settings', icon: 'ow_clock1' }
      },
    ],
    branch: true
  },
  // {
  //   path: '/z/:branchId/notification',
  //   component: Layout,
  //   redirect: 'notification',
  //   name: 'Notification',
  //   meta: { title: 'Notification', icon: 'ow_clock1' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/notification/index'),
  //       meta: { title: 'Notification', icon: 'ow_clock1', badge: 'notification' }
  //     }
  //   ],
  //   branch: true
  // },
  {
    path: '/z/:branchId/trace',
    component: Layout,
    redirect: '',
    name: 'Trace',
    meta: { feature: 'trace', title: 'Trace', icon: 'ow_clock1' },
    children: [
      {
        path: 'stepalphas',
        component: () => import('@/views/trace/stepalphas'),
        meta: { traceSidebar: 'alpha', title: 'Step Alpha', icon: 'ow_clock1' }
      },
      {
        path: 'stepbravos',
        component: () => import('@/views/trace/stepbravos'),
        meta: { traceSidebar: 'bravo', title: 'Step Bravo', icon: 'ow_clock1' }
      },
      {
        path: 'stepcharlies',
        component: () => import('@/views/trace/stepcharlies'),
        meta: { traceSidebar: 'charlie', title: 'Step Charlie', icon: 'ow_clock1' }
      },
      {
        path: 'stepdeltas',
        component: () => import('@/views/trace/stepdeltas'),
        meta: { traceSidebar: 'delta', title: 'Step Delta', icon: 'ow_clock1' }
      },
      {
        path: 'stepechos',
        component: () => import('@/views/trace/stepechos'),
        meta: { traceSidebar: 'echo', title: 'Step Echo', icon: 'ow_clock1' }
      },
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/trace/settings',
    component: Layout,
    redirect: '',
    name: 'Settings',
    meta: { feature: 'trace', title: 'Settings', icon: 'ow_clock1' },
    children: [
      {
        path: 'settings',
        component: () => import('@/views/trace/settings'),
        meta: { title: 'Settings', icon: 'ow_clock1' }
      },
    ],
    alwaysShow: true,
    branch: true
  },

  // default - has branch
  {
    path: '/z/:branchId/branch',
    component: Layout,
    redirect: 'profile',
    name: 'Co. Settings',
    meta: { title: 'Co. Settings', icon: 'ow_clock1' },
    children: [
      {
        path: 'profile',
        component: () => import('@/views/settings/branch/profile'),
        meta: { title: 'Profile', icon: 'ow_clock1' }
      },
      {
        path: 'email',
        component: () => import('@/views/settings/branch/email'),
        meta: { title: 'Email', icon: 'ow_clock1' }
      },
      {
        path: 'collaborator',
        component: () => import('@/views/settings/branch/collaborator'),
        meta: { title: 'Collaborator', icon: 'ow_clock1' }
      }
    ],
    branch: true
  },
  {
    path: '/z/:branchId/account',
    component: Layout,
    redirect: 'profile',
    name: 'User Settings',
    meta: { title: 'User Settings', icon: 'ow_clock1' },
    children: [
      {
        path: 'profile',
        component: () => import('@/views/settings/user/profile'),
        meta: { title: 'Profile', icon: 'ow_clock1' }
      },
      {
        path: 'password',
        component: () => import('@/views/settings/user/password'),
        meta: { title: 'Password', icon: 'ow_clock1' }
      }
    ],
    branch: true
  },
  // {
  //   path: '/z/:branchId/branches',
  //   component: Layout,
  //   redirect: 'branches',
  //   name: 'Branches',
  //   meta: { title: 'Branches' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/admin/companies/index'),
  //       meta: { title: 'Branches', icon: 'ow_clock1' }
  //     }
  //   ],
  //   branch: true
  // },
  {
    path: '/z/:branchId/default',
    component: Layout,
    redirect: '',
    name: 'Default',
    meta: { title: 'Default' },
    children: [
      {
        path: '',
        component: () => import('@/views/admin/default/index'),
        meta: { title: 'Default', icon: 'ow_clock1' }
      }
    ],
    hidden: true,
    branch: true
  },

  // default - no branch
  {
    path: '/branch',
    component: Layout,
    redirect: 'profile',
    name: 'Co. Settings',
    meta: { title: 'Co. Settings', icon: 'ow_clock1' },
    children: [
      {
        path: 'profile',
        component: () => import('@/views/settings/branch/profile'),
        meta: { title: 'Profile', icon: 'ow_clock1' }
      },
      {
        path: 'email',
        component: () => import('@/views/settings/branch/email'),
        meta: { title: 'Email', icon: 'ow_clock1' }
      },
      {
        path: 'collaborator',
        component: () => import('@/views/settings/branch/collaborator'),
        meta: { title: 'Collaborator', icon: 'ow_clock1' }
      }
    ]
  },
  {
    path: '/account',
    component: Layout,
    redirect: 'profile',
    name: 'User Settings',
    meta: { title: 'User Settings', icon: 'ow_clock1' },
    children: [
      {
        path: 'profile',
        component: () => import('@/views/settings/user/profile'),
        meta: { title: 'Profile', icon: 'ow_clock1' }
      },
      {
        path: 'password',
        component: () => import('@/views/settings/user/password'),
        meta: { title: 'Password', icon: 'ow_clock1' }
      }
    ]
  },
  // {
  //   path: '/email',
  //   component: Layout,
  //   redirect: 'email',
  //   name: 'Email',
  //   meta: { title: 'Email', icon: 'ow_clock1' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/email/index'),
  //       meta: { title: 'Email', icon: 'ow_clock1' }
  //     }
  //   ],
  //   branch: false
  // },
  // {
  //   path: '/branches',
  //   component: Layout,
  //   redirect: 'branches',
  //   name: 'Branches',
  //   meta: { title: 'Branches' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/admin/companies/index'),
  //       meta: { title: 'Branches', icon: 'ow_clock1' }
  //     }
  //   ],
  //   branch: false
  // },
  // {
  //   path: '/dashboard',
  //   component: Layout,
  //   redirect: 'dashboard',
  //   name: 'Dashboard',
  //   meta: { title: 'Dashboard' },
  //   children: [{
  //     path: '',
  //     component: () => import('@/views/admin/dashboard/index'),
  //     meta: { title: 'Dashboard', icon: 'el-icon-monitor' }
  //   },
  //   {
  //     path: 'instance',
  //     component: () => import('@/views/admin/dashboard/index'),
  //     name: 'New Instance',
  //     meta: { title: 'New Instance' },
  //     hidden: true
  //   }]
  // },
  {
    path: '/users',
    component: Layout,
    redirect: 'users',
    name: 'Users',
    meta: { roles: ['generalmanager'], title: 'Users' },
    children: [{
      path: '',
      component: () => import('@/views/admin/users/index'),
      meta: { title: 'Users', icon: 'ow_clock1' }
    }]
  }
  // { path: '*', redirect: '/404', hidden: true }
]



// WEBPACK FOOTER //
// ./src/router/index.js